module.exports = __webpack_public_path__ + "static/img/AAGC.ed3331bf.png";